import { render, staticRenderFns } from "./InformationCountModal.vue?vue&type=template&id=272d5fbc&scoped=true&"
import script from "./InformationCountModal.vue?vue&type=script&lang=ts&"
export * from "./InformationCountModal.vue?vue&type=script&lang=ts&"
import style0 from "./InformationCountModal.vue?vue&type=style&index=0&id=272d5fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d5fbc",
  null
  
)

export default component.exports